'use client';

import React, { forwardRef } from 'react';
import { cn } from '../../utils/cn';

export interface DialogHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
}

export const DialogHeader = forwardRef<HTMLDivElement, DialogHeaderProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <div ref={ref} className={cn('border-b border-velux-ui-grey p-4', className)} {...props}>
        {children}
      </div>
    );
  }
);

DialogHeader.displayName = 'DialogHeader';
